module.exports = __webpack_public_path__ + "media/icons/widget-logo-17ae9007.svg";